<div class="min-h-screen flex items-center justify-center relative bg-cover bg-center bg-no-repeat p-4" [style.background-image]="'url(' + backgroundImageUrl + ')'">
  <div class="absolute inset-0 bg-white/10 backdrop-blur-[2px]"></div>
  
  <div class="relative z-10 w-full max-w-[450px]">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="bg-white rounded-xl p-10 sm:p-8 sm:px-6 shadow-2xl flex flex-col gap-6 relative overflow-visible">
      <!-- Logo -->
      <div class="flex justify-center items-center mt-0 p-0 relative z-10 min-h-[60px] sm:min-h-[50px] max-h-[80px] sm:max-h-[70px] overflow-visible w-full">
        <app-image-tag 
          [src]="logoUrl" 
          [alt]="companyName + ' Logo'" 
          class=" h-8 w-8"
          [preventDownload]="true">
        </app-image-tag>
      </div>

      <!-- Platform Admin Title -->
      <div class="text-center">
        <h1 class="text-2xl font-bold text-gray-900 mb-1">{{ companyName }} Login</h1>
        <p class="text-sm text-gray-600">SaaS Control Panel</p>
      </div>

      <!-- Email Input Only (no mobile option for Platform Admin) -->
      <app-input
        type="email"
        label="Email"
        [required]="true"
        placeholder="Enter your admin email"
        formControlName="username"
        id="email"
        name="email">
      </app-input>

      <!-- Password Input -->
      <app-input
        type="password"
        label="Password"
        [required]="true"
        placeholder="Enter your password"
        formControlName="password"
        [showPasswordToggle]="true"
        id="password"
        name="password">
      </app-input>

      <!-- Login Button -->
      <app-button
        type="submit"
        variant="primary"
        [fullWidth]="true"
        [loading]="isLoading()"
        [disabled]="isLoading()">
        {{ isLoading() ? 'Logging in...' : 'Login to Platform Admin' }}
      </app-button>

      <!-- Forgot Password Link -->
      <a [routerLink]="['/admin/forgot-password']" class="text-center text-primary-600 underline text-sm cursor-pointer transition-colors duration-200 hover:text-primary-700">
        Forgot your password?
      </a>

      <!-- Footer -->
      <div class="flex flex-col items-center gap-2 mt-4 pt-4 border-t border-gray-200">
        <app-image-tag 
          [src]="logoUrl" 
          [alt]="companyName + ' Logo'" 
          class="h-8 w-8 object-contain"
          [preventDownload]="true">
        </app-image-tag>
        <p class="text-xs text-gray-500 m-0">Powered by {{ poweredBy }}</p>
      </div>
    </form>
  </div>
</div>
